import axios from "axios";


const fetchAppointments = async (email) => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/fetch/calendar?email=${email}`);
        return response.data.appointments.map(appointment => ({
            start: new Date(appointment.start),
            end: new Date(appointment.end),
        }));
    } catch (error) {
        console.error('Failed to fetch appointments:', error);
        throw error;
    }
};

export default {
    fetchAppointments
};
